module.exports = "/_next/static/images/icon-markets-no-data-e8861df51333c6be9a0494ca38f37953.svg";